import { KeyboardLayout, KeysValue, KeyboardRows } from './types';

// Added custom Portuguese layout as library doesn't have it, Placed an request to add the same to the library. Once it is available we can remove this.
export const ptBRLayout: KeyboardLayout = {
  layout: {
    default: [
      '\u007E 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      '{tab} q w e r t y u i o p \u005E \u0302 [ ]',
      "{lock} a s d f g h j k l \u00E7 ' ` \u00B4 {enter}",
      '{shift} \\ z x c v b n m , . / {shift}',
      '.com @ {space}'
    ],
    shift: [
      '! @ # $ % & * ( ) _ + {bksp}',
      '{tab} Q W E R T Y U I O P \u005E { }',
      '{lock} A S D F G H J K L \u00C7 " : ; {enter}',
      '{shift} | Z X C V B N M < > ? {shift}',
      '.com @ {space}'
    ]
  }
};

export const ptPTLayout: KeyboardLayout = {
  layout: {
    default: [
      '\u005E \u007E 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      '{tab} q w e r t y u i o p ; : \u0302 \u0308',
      '{lock} a s d f g h j k l \u00E7 \u00B4 \u0300 {enter}',
      "{shift} \\ z x c v b n m , . / ' {shift}",
      '.com @ {space}'
    ],
    shift: [
      '{//} ! @ # $ % & * ( ) _ + {bksp}',
      '{tab} Q W E R T Y U I O P { }',
      '{lock} A S D F G H J K L \u00C7 \u0308 \u0300 {enter}',
      '{shift} | Z X C V B N M < > ? " {shift}',
      '.com @ {space}'
    ]
  }
};

// Added custom French (Canada) keyboard to keep the English qwerty layout instead of the French azerty layout
export const frCALayout: KeyboardLayout = {
  layout: {
    default: [
      '| 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      '{tab} q w e r t y u i o p [ ] /',
      '{lock} a s d f g h j k l m ´ ` {enter}',
      '{shift} < z x c v b n , ; : ! {shift}'
    ],
    shift: [
      '~ \u00B2 & é " \' ( § è _ ç à ) = {bksp}',
      '{tab} Q W E R T Y U I O P { } \\',
      '{lock} A S D F G H J K L M % Ù {enter}',
      '{shift} > Z X C V B N ? . * ^ {shift}'
    ]
  }
};

export const getAllKeys = (defaultLayout: any) => {
  return (
    defaultLayout && [
      {
        label: 'First row',
        keys: defaultLayout[0]
          .split(' ')
          .filter((key: any) => !key.match(/^{.*}$/))
          .map((key: any) => `'${key}'`)
          .map((elem: any) => {
            return elem === "'''" ? "'" : elem.replace(/'/g, '');
          })
      },
      {
        label: 'Second row',
        keys: defaultLayout[1]
          .split(' ')
          .filter((key: any) => !key.match(/^{.*}$/))
          .map((key: any) => `'${key}'`)
          .map((elem: any) => {
            return elem === "'''" ? "'" : elem.replace(/'/g, '');
          })
      },
      {
        label: 'Third row',
        keys: defaultLayout[2]
          .split(' ')
          .filter((key: any) => !key.match(/^{.*}$/))
          .map((key: any) => `'${key}'`)
          .map((elem: any) => {
            return elem === "'''" ? "'" : elem.replace(/'/g, '');
          })
      },
      {
        label: 'Fourth row',
        keys: defaultLayout[3]
          .split(' ')
          .filter((key: any) => !key.match(/^{.*}$/))
          .map((key: any) => `'${key}'`)
          .map((elem: any) => {
            return elem === "'''" ? "'" : elem.replace(/'/g, '');
          })
      }
    ]
  );
};

export const updateKeys = (keys: KeysValue, defaultlangKeys: any, shiftlangKeys: any) => {
  const lowerCase: KeyboardRows = {
    rowOne: defaultlangKeys && defaultlangKeys[0].keys,
    rowTwo: defaultlangKeys && defaultlangKeys[1].keys,
    rowThree: defaultlangKeys && defaultlangKeys[2].keys,
    rowFour: defaultlangKeys && defaultlangKeys[3].keys
  };

  const upperCase: KeyboardRows = {
    rowOne: shiftlangKeys && shiftlangKeys[0].keys,
    rowTwo: shiftlangKeys && shiftlangKeys[1].keys,
    rowThree: shiftlangKeys && shiftlangKeys[2].keys,
    rowFour: shiftlangKeys && shiftlangKeys[3].keys
  };

  const keyboardValues = { lowerCase, upperCase };

  return keyboardValues[keys];
};
